import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoriesSection() {
  const displayCategories = categories.slice(0, 8);

  return (
    <section className="w-full py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
            探索兴趣领域
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            八大热门兴趣分类，找到属于你的社群
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {displayCategories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
              className="group relative overflow-hidden rounded-lg bg-background-100 hover:bg-background-200 transition-colors duration-300 cursor-pointer"
            >
              <div className="relative h-36 md:h-44 overflow-hidden">
                <img
                  src={cat.image}
                  alt={`17c一起${cat.name}`}
                  title={`17c一起${cat.name}活动`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
              </div>
              <div className="p-4">
                <div className="flex items-center gap-2 mb-1">
                  <div className="w-7 h-7 flex items-center justify-center">
                    <i className={`${cat.icon} text-primary-500 text-lg`}></i>
                  </div>
                  <h3 className="text-sm font-label font-medium text-foreground-900 whitespace-nowrap">
                    {cat.name}
                  </h3>
                </div>
                <p className="text-xs text-foreground-500 line-clamp-2 leading-relaxed">
                  {cat.description}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}